export default __webpack_public_path__ + "static/media/skippedmeal_2@2x.b51bbbbe.jpg";